<template>
  <div class="resign">
  	<Loading v-show="loading"></Loading>
  	<h2>退会手続きについて</h2>
  	<div class="resign-inner">
	  	<p>・退会手続きを済ませると、期限日を最後にクレジットカード払いが終了いたします。</p>
	  	<p>・一度退会をすると、アカウント情報は削除されるため再ログインはすることはできなくなります。</p>
	  	<p>・再度、入会される場合はサイトトップから新規登録を行いましょう</p>
	  	<!--退会規約に同意する-->
	  	<input type="checkbox" id="checkbox" v-model="checked">
	  	<label for="checkbox">退会規約に同意する</label>
	  	<!--退会する-->
	  	<div class="button-contents">
	  		<button v-on:click="resign()" id="resign">退会する</button>
	  	</div>
  	</div>
  </div>
</template>
<style scoped>
	.resign-inner{
		text-align: left;
		width: 60%;
		margin: 0 auto;
	}
  .resign-inne p{
    font-style: normal;
    text-align: left;
  font-family: Hiragino Kaku Gothic Pro;
  }
  #checkbox{
    margin-top: 5%;
  }
  #resign{
    background: red;
    color: white;
    width: 200px;
    border:0px;
    margin-top: 5%;
    padding: 16px;
    font-size: 18px;

  }
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Resign',
  components: {
    Loading
  },
  data () {
    return {
      userId: null,
      db: null,
      loading: false,
      checked: false,
      customerId: null
    }
  },
  methods: {
  	resign: function () {
      let self = this
      if (this.checked) {
        // PayJpはキャンセル(顧客情報等は残す)
        self.loading = true
        console.log(this.customerId)
        var data = {'id': this.customerId}
              $.ajax({
                url: 'https://weart-marketing.com/api/7200kcal/stopSubscription/',
                type: 'POST',
                data: data
              })
              .done(function (data) {
                self.deleteUserClass()
              })
              .fail(function (error) {
                self.loading = false
                alert('購入に失敗しました、カード情報が正しいか再度チェックしてから、ご購入の手続きをお願い致します。')
              })
        // ユーザー情報は削除する
      } else {
        alert('退会規約に同意する同意してから退会するボタンをクリックしてください。')
      }
  	},
    deleteUserClass: function () {
      let self = this
      self.loading = true
      this.db.collection('users').doc(this.userId).delete().then(function() {
          alert('アカウント削除に成功しました。今までありがとうございました。')
          localStorage.clear()
          location.href = '/'
        }).catch(function(error) {
          alert('プロフィール削除に失敗しました。再度、実行してください。')
          self.loading = false
        })
    },
    isUser: function () {
      let self = this
      var exist = false
      var docRef = self.db.collection("users").doc(this.userId);
      docRef.get().then(function(doc) {
        if (doc.exists) {
          self.customerId = doc.get('customer')
        } else {
          alert('ユーザーが存在しません、。再度ログインしなおしてください。')
          location.href='/'
        }
      }).catch(function(error) {
          alert('サーバーエラーが発生しました。再度ログインしなおしてください。')
          location.href='/'
      });

    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.userId = result['userId']
    if (!this.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {
      //this.getRecipes()
      self.isUser()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/resign/Resign.vue